import React from 'react';
import { ThemeProvider } from '@material-ui/styles';
import { createTheme } from '@material-ui/core/styles';
import { SITE_FONT_FAMILY } from './fonts';

const theme = createTheme({
    palette: {
        primary: {
            main: '#56b2e3',
            contrastText: '#fff'
        },
        secondary: {
            main: '#0284c7',
        },
        text: {
            primary: '#0f172a',
            secondary: '#475569',
        },
        background: {
            default: '#ffffff',
            paper: '#ffffff',
        },
    },
    shape: {
        borderRadius: 10,
    },
    typography: {
        fontFamily: SITE_FONT_FAMILY,
        fontSize: 15,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        h1: {
            fontWeight: 700,
            letterSpacing: '-0.035em',
            lineHeight: 1.15,
            color: '#0f172a',
        },
        h2: {
            fontWeight: 700,
            letterSpacing: '-0.03em',
            lineHeight: 1.2,
            color: '#0f172a',
        },
        h3: {
            fontWeight: 700,
            letterSpacing: '-0.025em',
            lineHeight: 1.25,
            color: '#0f172a',
        },
        h4: { fontWeight: 600, letterSpacing: '-0.02em', color: '#0f172a' },
        h5: { fontWeight: 600, letterSpacing: '-0.015em', color: '#0f172a' },
        h6: { fontWeight: 600, letterSpacing: '-0.01em', color: '#0f172a' },
        subtitle1: { letterSpacing: '-0.015em', color: '#475569' },
        subtitle2: { letterSpacing: '-0.01em', fontWeight: 600, color: '#334155' },
        body1: { letterSpacing: '-0.01em', color: '#475569' },
        body2: { letterSpacing: '-0.005em', color: '#475569' },
        button: {
            fontWeight: 600,
            letterSpacing: '-0.01em',
            textTransform: 'none',
        },
        caption: { letterSpacing: '0.02em', color: '#64748b' },
    },
});

export default function MaterialUITheme ({ children }) {
    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    );
}
